import React, { useEffect, useState } from "react";
import { Typography, IconButton, Box, Avatar } from "@mui/material";

import "./AgentProfilePicture.scss";
import { getCdnImageUrl, getImageUrl } from "../../../../utils/helpers/common";
import Upload from "../../../../components/icons/Upload";

const AgentProfilePicture = ({
  profileImage,
  setProfileImage,
  formik,
}: {
  profileImage: any;
  setProfileImage: any;
  formik: any;
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [state, setState] = useState({
    imageUrl: "",
  });

  const getProfileImageUrl = (uploadRecord: any) => {
    if (!uploadRecord) return "";

    if (uploadRecord.small_image_url) {
      return getCdnImageUrl(uploadRecord.small_image_url);
    }

    if (uploadRecord.medium_image_url) {
      return getCdnImageUrl(uploadRecord.medium_image_url);
    }

    if (uploadRecord.storage_key) {
      return getCdnImageUrl(uploadRecord.storage_key);
    }

    if (uploadRecord.original_file_path) {
      return getImageUrl(uploadRecord.original_file_path);
    }

    if (uploadRecord.compressed_file_path) {
      return getImageUrl(uploadRecord.compressed_file_path);
    }

    return "";
  };

  const handleDeleteImage = () => {
    setProfileImage(null);
    formik.setFieldValue("profileImageLive", "");
    formik.setFieldValue("profileImageUploadRecord", null);
  };

  const handleImageChange = (e: any) => {
    let file = e.target.files[0];
    if (!file) return;

    formik.setFieldValue("profileImageLive", file.name);
    setProfileImage(file);
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];

    // const reader = new FileReader();

    // reader.addEventListener(
    //   "load",
    //   () => {
    //     console.log("reader.result", reader.result);
    //     // render.src = reader.result;
    //   },
    //   false
    // );

    // if (file) {
    //   reader.readAsDataURL(file);
    // }

    if (file) {
      formik.setFieldValue("profileImageLive", file.name);
      setProfileImage(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDragEnter = () => setIsDragging(true);

  const handleDragLeave = () => setIsDragging(false);

  useEffect(() => {
    let imageUrl = "";

    if (profileImage) {
      imageUrl = URL.createObjectURL(profileImage);
    } else if (formik?.values?.profileImageUploadRecord) {
      imageUrl = getProfileImageUrl(formik.values.profileImageUploadRecord);
    } else if (formik?.values?.profileImageLive?.trim()) {
      const url = formik.values.profileImageLive;
      if (url.includes("profile-images/") && !url.startsWith("http")) {
        imageUrl = getCdnImageUrl(url);
      } else {
        imageUrl = getImageUrl(url);
      }
    }

    if (imageUrl?.includes("undefined")) imageUrl = "";

    setState((prev) => ({
      ...prev,
      imageUrl,
    }));
  }, [
    profileImage,
    formik?.values?.profileImageLive,
    formik?.values?.profileImageUploadRecord,
  ]);

  return (
    <div className="upload-profile-image">
      {state.imageUrl ? (
        <Box textAlign="center">
          <Avatar
            src={state.imageUrl}
            alt="Profile Picture"
            variant="rounded"
            className="profile-avatar"
          />
          <Box display="flex" gap={2}>
            {/* <button className="delete-button" onClick={handleDeleteImage}>
              Delete
            </button> */}
            {/* <button className="update-button">
              Change Photo
              <input type="file" onChange={handleImageChange} />
            </button> */}
          </Box>
        </Box>
      ) : (
        <Box
          className={`profile-picture-upload ${isDragging ? "dragging" : ""}`}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <Box
            component="label"
            className={`upload-box ${
              formik?.errors?.profileImageLive ? "upload-box-error" : ""
            }`}
          >
            <input type="file" hidden onChange={handleImageChange} />
            <Box className="upload-content">
              <IconButton
                aria-label="upload"
                color="default"
                size="large"
                className="upload-icon"
              >
                <Upload />
              </IconButton>
              <Typography variant="body2" color="textSecondary">
                {isDragging ? "Release to Upload" : "Drop or Select file"}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default AgentProfilePicture;
